
export const SCENARIO_GENERIC_TYPES = {
    'SIMULATION': 'simulation',
    'OPENCENARIO': 'open_scenario',
    'QUICK_DEPLOY': 'quick_deploy',
}


export const SCENARIO_OPERATION_TYPES = {
    'LEOP': 'LEOP',
    'CONOPS': 'CONOPS',
    'MANUAL': 'Manual'
}

export const SCENARIO_DEPLOYMENT_TYPES = {
    'SIMULATE': 'SIMULATE',
    'OPERATE': 'OPERATE',
    'QUICK_DEPLOY': 'QUICK_DEPLOY',
    'HARDWARE_IN_LOOP': 'HARDWARE_IN_LOOP',
    'TRUETWIN_COMMAND_CENTER': 'TRUETWIN_COMMAND_CENTER',
    'GENERIC_SIMULATE': 'GENERIC_SIMULATE',
    'VALIDATE': 'VALIDATE',
}

export const SCENARIO_STEPS = {
    'DETAILS': 'details',
    'SATELLITES': 'satellites',
    'HWIL': 'hwil',
    'INITIAL_ALTITUDE': 'initial-altitude',
    'SEGMENTS': 'segments',
    'FEATURES': 'features',
    'SCHEDULE': 'schedule',
    'FAULTS': 'faults',
    'ASSETS': 'assets',
    'CONNECT': 'connect',
    'RECONNECT': 're-connect',
    'DEPLOY': 'deploy',
    'START_SIMULATION': 'start-simulation',
}

export const SCENARIO_STEPS_ORDER = [
    SCENARIO_STEPS.DETAILS,
    SCENARIO_STEPS.SATELLITES,
    SCENARIO_STEPS.INITIAL_ALTITUDE,
    SCENARIO_STEPS.HWIL,
    SCENARIO_STEPS.SEGMENTS,
    SCENARIO_STEPS.SCHEDULE,
    SCENARIO_STEPS.FAULTS,
    SCENARIO_STEPS.ASSETS,
    SCENARIO_STEPS.DEPLOY,
    SCENARIO_STEPS.CONNECT,
    SCENARIO_STEPS.RECONNECT,
    SCENARIO_STEPS.START_SIMULATION,
];

export const SCENARIO_STATUS = {
    'CONFIGURE': 'Configure',
    'READY_FOR_SIMULATION': 'ReadyForSimulation',
    'HWIL_CONFIG_GENERATED': 'HwilConfigGenerated',
    'WAITING_FOR_CONNECTION': 'WaitingForConnection',
    'DEPLOYMENT_IN_PROGRESS': 'DeploymentInProgress',
    'SIMULATION_RUNNING': 'SimulationRunning',
    'UNDEPLOY_IN_PROGRESS': 'UnDeployInProgress',
    'SIMULATION_COMPLETED': 'SimulationCompleted',
    'REDEPLOY_SCENARIO': 'RedeployScenario',
}

export const ORBIT_EXPOSER_TYPES = {
    "ECLIPSE": "Eclipse",
    "BOTH": "Both",
    "SUNLIT": "Sunlit"
}